/**
 * Mirrors packages/amgbandarqq_v2 endpoint and game-key constants
 * (data/repositories/game_repository.dart + screens/lobby_screen.dart).
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

/** game_repository.dart:11-14 */
export const GAME_KEY_SINGLE = 'BDQ1';
export const GAME_KEY_MULTI = 'BDQM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/bandarqqhub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — matches the Flutter design canvas (1792×828). */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/** lobby_screen.dart defaults: user2 / 123456 (any v2 game uses the same). */
export const DEFAULT_USER_NAME = 'user5';
export const DEFAULT_PASSWORD = '123456';

/** Defaults if /getinfo never returns chip/limit config. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 10,
  maxBet: 10000,
  chipValues: [10, 50, 100, 500, 1000, 5000] as const,
};

/**
 * Single-player: hold the "no more bet" banner (triEndBet) this long after
 * confirm before revealing the dominoes. Mirrors game_bloc.dart
 * `_scheduleNoMoreBetEndFallback` (900 ms) — the reveal is gated behind the
 * noMoreBet animation, not fired immediately.
 */
export const NO_MORE_BET_HOLD_MS = 900;

/**
 * Result-sequence pacing, measured from the domino reveal. Mirrors the
 * `resultStop` timeline in game_bloc.dart `_onStartResultSequence`:
 *   t=2s  chips fly to winner/dealer (+ history already updated)
 *   t=5s  win/lose panel
 *   t=13s teardown → next betting round
 * The result (dominoes + VS) stays on screen for the full ~13 s, unlike the old
 * event-driven teardown which cleared it after a couple of seconds.
 */
export const RESULT_CHIPS_DELAY_MS = 2000;
export const RESULT_WIN_LOSE_DELAY_MS = 5000;
export const RESULT_NEW_ROUND_DELAY_MS = 13000;

/** ms — small settle delay between teardown and the next betting round. */
export const NEW_ROUND_DELAY_MS = 1000;
